import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components/macro';
import Animation from 'components/Animation/Animation';
import { useFormatMessage } from 'components/IntlProvider';
import { Dashboard } from 'components/Layout';

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin-top: 5rem;
`;

const WipPlaceholder = ({ location }: RouteComponentProps) => {
  const t = useFormatMessage();
  return (
    <Dashboard title="Work in progress" location={location}>
      <Container>
        <Animation
          width="300px"
          height="300px"
          type="we-changing"
          text={t(
            'workInProgress',
            'We are constantly changing for the better'
          )}
        />
      </Container>
    </Dashboard>
  );
};

export default WipPlaceholder;
